export function assertIsDefined<T>(value: T, message?: string): asserts value is NonNullable<T> {
    if (value === undefined || value === null) {
        throw new Error(message ?? 'Expected value to be defined');
    }
}

export function isDefined<T>(value: T): value is NonNullable<T> {
    return value !== undefined && value !== null;
}
